<template>
  <div class="accordion-faq">
    <div class="accordion" id="accordionOne">
      <details v-for="(faq, faqidx) in faqs" :key="faqidx" class="accordion-item" :open="faq.show" @toggle="toggleFaq($event, faq, faqidx)">
        <summary class="accordion-button" :class="{ collapsed: !faq.show }">
          <h3 class="accordion-question">{{ faq.title }}</h3>
        </summary>
        <div class="accordion-body" v-html="faq.body"></div>
      </details>
    </div>
  </div>
</template>

<script>
import homeFaqs from "../data/homeFaqs";
import { trackEvent } from "../utils/analytics";

export default {
  name: "Accordion",
  data() {
    return {
      faqs: homeFaqs.map((faq, index) => ({ ...faq, show: index === 0 })),
    };
  },
  methods: {
    toggleFaq(event, faq, index) {
      if (faq.show === event.target.open) return;
      faq.show = event.target.open;
      if (faq.show) {
        trackEvent("faq_open", {
          faq_id: `faq_${index + 1}`,
          faq_question: faq.title,
        });
      }
    },
  },
};
</script>

<style scoped>
.accordion-button { cursor: pointer; list-style: none; }
.accordion-button::-webkit-details-marker { display: none; }
.accordion-question { margin: 0; font-size: inherit; font-weight: inherit; color: inherit; }

.accordion-item {
  overflow: hidden;
  border: 1px solid #e5eaf1;
  box-shadow: none;
}

.accordion-item + .accordion-item {
  margin-top: 12px;
}

.accordion-body {
  color: #5a6e8e;
  line-height: 1.85;
}

.accordion-body :deep(a) {
  color: #d9317c;
  font-weight: 500;
}

.accordion-body :deep(a:hover) {
  color: #364563;
}
</style>
